import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DesignAngularKitModule } from 'design-angular-kit';

@Component({
  selector: 'app-complete-request-modal',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule, FormsModule],
  templateUrl: './complete-request-modal.component.html',
  styleUrl: './complete-request-modal.component.scss',
})
export class CompleteRequestModalComponent {
  // Falso solo se il segnalante è un PUA o un MMG (paziente eventualmente già a domicilio)
  @Input() dischargeRequired = true;
  @Output() cancelled = new EventEmitter<void>();
  @Output() requestConfirmed = new EventEmitter<{ dischargeDate: Date | null, dischargeTime: string | null, note: string | null }>();

  dischargeDate: Date | null = null;
  dischargeTime: string | null = null;
  note: string = '';

  // Se facoltative, data e ora di dimissione vanno comunque indicate insieme
  get isDischargeIncomplete(): boolean {
    return !!this.dischargeDate !== !!this.dischargeTime;
  }

  get isConfirmDisabled(): boolean {
    return this.dischargeRequired
      ? !this.dischargeDate || !this.dischargeTime
      : this.isDischargeIncomplete;
  }

  cancel(): void {
    this.cancelled.emit();
  }
  confirm() {
    this.requestConfirmed.emit({dischargeDate: this.dischargeDate, dischargeTime: this.dischargeTime, note: this.note});
  }
}
